import React, { ReactElement } from 'react';

const StatusWarning = (): ReactElement => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="solid/Alert">
        <path
          id="icon_art"
          d="M0 20L9.98185 0L19.9637 20H0ZM9.98185 16.8421C10.239 16.8421 10.4545 16.7412 10.6284 16.5395C10.8023 16.3377 10.8893 16.0877 10.8893 15.7895C10.8893 15.4912 10.8023 15.2412 10.6284 15.0395C10.4545 14.8377 10.239 14.7368 9.98185 14.7368C9.72474 14.7368 9.50923 14.8377 9.3353 15.0395C9.16137 15.2412 9.07441 15.4912 9.07441 15.7895C9.07441 16.0877 9.16137 16.3377 9.3353 16.5395C9.50923 16.7412 9.72474 16.8421 9.98185 16.8421ZM9.07441 13.6842H10.8893V8.42105H9.07441V13.6842Z"
          fill="#DD0B24"
        />
      </g>
    </svg>
  );
};

export default StatusWarning;
